import { useEffect, useState } from "react";
import axios, { API } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import DatePicker from "@/components/site/DatePicker";

export default function RescheduleDialog({ booking, open, onOpenChange, onSubmit }) {
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [taken, setTaken] = useState([]);
  useEffect(() => {
    if (!open) return;
    setDate(""); setNote("");
    axios.get(`${API}/booked-dates`).then((r) => setTaken(r.data.filter((d) => d !== booking.date))).catch(() => {});
  }, [open, booking.date]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0A1325] border-[#D4AF37]/40 rounded-none" data-testid="reschedule-dialog">
        <DialogHeader><DialogTitle className="font-display text-3xl">Changer la date</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-400">Date actuelle : {new Date(`${booking.date}T00:00:00`).toLocaleDateString("fr-FR", { dateStyle: "full" })}</p>
        <DatePicker value={date} onChange={setDate} booked={taken} />
        <label className="block text-sm"><span className="text-slate-400">Message au client (facultatif)</span>
          <textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} data-testid="reschedule-note-input"
            className="w-full bg-[#050B14] border border-white/15 px-3 py-2.5 outline-none focus:border-[#D4AF37]" /></label>
        <DialogFooter>
          <button disabled={!date} onClick={() => onSubmit({ date, note })} data-testid="reschedule-confirm-btn"
            className="bg-[#D4AF37] text-[#050B14] px-6 py-3 font-medium hover:bg-[#e6c55a] disabled:opacity-50 transition-colors duration-300">
            Déplacer et prévenir le client
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
